{
  "title": "Règles d’affectation",
  "subtitle": "Évaluées de haut en bas. La première règle qui correspond à un expéditeur l’emporte et l’évaluation s’arrête.",
  "newRule": "Nouvelle règle",
  "testRules": "Tester un expéditeur",
  "loadError": "Impossible de charger les règles",
  "emptyTitle": "Aucune règle pour l’instant",
  "emptyBody": "Sans valeur par défaut ni règle, rien n’est estampillé : chaque message est relayé tel quel. Définissez une signature par défaut dans Utilisateurs, ou ajoutez une règle plus précise ici.",
  "tenantDefault": "Valeur par défaut du locataire",
  "tenantDefaultHint": "S’applique lorsqu’aucune règle opérateur ne correspond.",
  "reorderError": "Impossible de réordonner les règles.",
  "reorderFailed": "Échec du réordonnancement.",
  "deleteRule": "Supprimer la règle",
  "deleteConfirm": "Supprimer « {{name}} » ?",
  "deleted": "« {{name}} » supprimée.",
  "deleteError": "Impossible de supprimer cette règle.",
  "editRule": "Modifier « {{name}} »",
  "createRule": "Nouvelle règle",
  "ruleName": "Nom",
  "ruleNamePlaceholder": "Ventes — mention externe",
  "enabled": "Activée",
  "disabled": "Désactivée",
  "template": "Modèle",
  "injectionMode": "Chemin d’injection",
  "injectionBoth": "Les deux",
  "injectionBothPaths": "Les deux chemins",
  "injectionMailFlow": "Flux de messagerie uniquement",
  "injectionClient": "Client uniquement",
  "injectionMailFlowShort": "Flux de messagerie",
  "injectionClientShort": "Client",
  "unknownPath": "Chemin inconnu",
  "recipientScope": "Destinataires",
  "recipientAny": "Tous",
  "recipientAnyFull": "Tout destinataire",
  "recipientInternal": "Internes uniquement",
  "recipientExternal": "Externes uniquement",
  "unknownRecipients": "Destinataires inconnus",
  "recipientsHint": "Jugé sur l’enveloppe. Un message sans destinataires ne satisfait ni interne ni externe, donc une règle ciblée ne correspond simplement pas plutôt que de deviner.",
  "templateNew": "Signature pour les nouveaux messages",
  "templateNewShort": "Nouveau : {{name}}",
  "templateNewNone": "Nouveau : aucun modèle",
  "templateReply": "Signature pour les réponses",
  "templateReplyShort": "Réponse : {{name}}",
  "templateReplySame": "Réponse : identique au nouveau",
  "templateNone": "Aucun",
  "templateReplyPlaceholder": "Identique aux nouveaux messages",
  "unknownTemplate": "Modèle inconnu",
  "appliesTo": "S’applique à",
  "except": "Sauf",
  "emptyScopeTitle": "Cette règle ne correspond à personne",
  "emptyScopeBody": "Une portée vide ne se déclenche jamais. Choisissez au moins une facette, ou activez Tout le monde.",
  "emptyScopeBadge": "Ne correspond à personne",
  "emptyScopeTooltip": "Une portée d’expéditeur vide ne correspond à personne, donc cette règle ne se déclenche jamais.",
  "hasExclusions": "A des exclusions",
  "addExclusions": "Ajouter des exclusions",
  "removeExclusions": "Retirer les exclusions",
  "exclusionsHint": "Les expéditeurs exclus passent aux règles de priorité inférieure plutôt que de perdre entièrement leur signature.",
  "saveRule": "Enregistrer la règle",
  "saved": "Règle enregistrée.",
  "saveError": "Impossible d’enregistrer la règle",
  "testerTitle": "Tester un expéditeur",
  "testerHint": "Choisissez une boîte pour voir quelle règle l’emporterait et quelle signature ils recevraient.",
  "senderAddress": "Adresse de l’expéditeur",
  "senderPlaceholder": "jordan.avery@contoso.com.au",
  "recipientsLabel": "Destinataires",
  "recipientsDescription": "Destinataires d’enveloppe. Les règles internes/externes uniquement sont jugées par rapport à ceux-ci.",
  "recipientsPlaceholder": "Ajoutez un destinataire et appuyez sur Entrée",
  "runTest": "Lancer le test",
  "testError": "Impossible d’exécuter le test",
  "noRuleMatched": "Aucune règle n’a correspondu",
  "noRulesEvaluated": "Aucune règle n’a été évaluée.",
  "colPriority": "Priorité",
  "colRule": "Règle",
  "colOutcome": "Résultat",
  "colWhy": "Pourquoi",
  "traceMatched": "Correspondance",
  "traceShadowed": "Masquée",
  "traceDisabled": "Désactivée",
  "traceSenderOutOfScope": "Expéditeur hors portée",
  "traceExcludedByRule": "Exclu par la règle",
  "traceRecipientScope": "Portée destinataires",
  "traceWrongPath": "Mauvais chemin",
  "traceNotEvaluated": "Non évaluée",
  "traceUnknown": "Inconnu",
  "excludedTitle": "L’expéditeur est exclu",
  "excludedBody": "Cette adresse est marquée comme exclue dans l’annuaire, donc son courrier est relayé intact et aucune règle n’est évaluée. Il n’y a rien à tracer.",
  "excludedHint": "L’exclusion est définie sur l’utilisateur de l’annuaire, pas dans ces règles. Effacez-la là-bas si cet expéditeur doit être estampillé.",
  "primaryDefault": "Valeur par défaut principale",
  "defaultBadge": "Par défaut",
  "everyone": "Tout le monde",
  "noMailboxesCovered": "Aucune boîte n’est encore couverte.",
  "mailboxesCovered": "{{count}} boîte couverte.",
  "mailboxesCovered_other": "{{count}} boîtes couvertes.",
  "mailboxesCoveredWithCustom": "{{count}} boîte couverte, {{custom}} avec une signature individuelle.",
  "mailboxesCoveredWithCustom_other": "{{count}} boîtes couvertes, {{custom}} avec une signature individuelle.",
  "managedOnUsers": "Géré dans l’",
  "usersTab": "onglet Utilisateurs",
  "changeDefault": "Modifier la valeur par défaut",
  "reorderAria": "Réordonner {{name}}",
  "moreActionsAria": "Plus d’actions pour {{name}}",
  "edit": "Modifier",
  "facetEveryone": "Tout le monde",
  "facetUsers": "Utilisateurs",
  "facetGroups": "Groupes",
  "facetDomains": "Domaines",
  "facetConditions": "Conditions",
  "everyoneLabel": "Appliquer à tout le monde dans le locataire",
  "everyoneDescription": "Le catch-all explicite. Sans lui, une portée sans autre facette ne correspond à personne.",
  "directoryUsers": "Utilisateurs de l’annuaire",
  "searchUsers": "Rechercher des utilisateurs",
  "userExcludedSuffix": " (exclu)",
  "emailAddresses": "Adresses e-mail",
  "emailAddressesDescription": "Comparées à chaque adresse proxy, donc les alias et boîtes partagées sont aussi résolus.",
  "emailAddressesPlaceholder": "nom@exemple.com",
  "groupsLabel": "Groupes",
  "searchGroups": "Rechercher des groupes",
  "groupsDescription": "L’appartenance imbriquée est aplatie à la synchronisation, donc un utilisateur dans un groupe imbriqué correspond.",
  "senderDomains": "Domaines de l’expéditeur",
  "senderDomainsDescription": "Comparé à la partie domaine de l’adresse d’envoi.",
  "senderDomainsPlaceholder": "contoso.com.au",
  "conditionsEmptyHint": "Aucune condition d’attribut. Ajoutez-en une pour cibler par service, bureau ou attribut personnalisé.",
  "facetsUnionHint": "Les facettes se combinent en union : toute personne correspondant à une facette est dans la portée.",
  "match": "Correspondance",
  "attribute": "Attribut",
  "usersHaveValue": "{{count}} utilisateurs ont une valeur",
  "attributeNotSeen": "Non observé sur aucun utilisateur synchronisé",
  "value": "Valeur",
  "valueInPlaceholder": "Ventes, Marketing",
  "removeCondition": "Supprimer la condition",
  "addCondition": "Ajouter une condition",
  "operatorEquals": "est",
  "operatorNotEquals": "n'est pas",
  "operatorContains": "contient",
  "operatorStartsWith": "commence par",
  "operatorEndsWith": "se termine par",
  "operatorIsEmpty": "est vide",
  "operatorIsNotEmpty": "n'est pas vide",
  "operatorIn": "fait partie de"
}
